import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description InterfaceHome icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { InterfaceHome } from '@sravni/design-system-icons'
 *
 * <InterfaceHome />
 * ```
 */
var InterfaceHome = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "InterfaceHome", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#InterfaceHome__a)" },
        React.createElement("path", { d: "M4.064 6.167V16.5h6.667m6.667-10.333v5.167", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M2.4 7.333 10.734 1.5l8.333 5.833M7.736 16v-5.25c0-.967.895-1.75 2-1.75h2c1.105 0 2 .783 2 1.75v2.625", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.798 13.285a.625.625 0 0 1-.606.643 2.27 2.27 0 1 0 2.123 3.222.625.625 0 1 1 1.134.527 3.516 3.516 0 0 1-3.189 2.042 3.52 3.52 0 0 1-.107-7.04c.346-.01.634.26.645.606Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.792 12.25a2.275 2.275 0 1 0 0 4.55 2.275 2.275 0 0 0 0-4.55Zm-3.524 2.274a3.525 3.525 0 1 1 7.049.001 3.525 3.525 0 0 1-7.05 0Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "InterfaceHome__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { InterfaceHome };
//# sourceMappingURL=InterfaceHome.js.map
